import { Component, HostListener, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'viva-info-popup',
    templateUrl: './viva-info-popup.component.html',
    styleUrls: ['./viva-info-popup.component.scss'],
    standalone: false
})
export class VivaInfoPopupComponent {

  readonly dialogTitleId = 'viva-info-popup-title';

  @Input() message?: string;
  @Input() buttonText?: string = 'info-popup-component.button-ok';

  constructor(private modalController: ModalController) { }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    void this.dismiss();
  }

 async dismiss() {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
    }
  }

}
